// extracted by extract-css-chunks-webpack-plugin
module.exports = {"controls":"role-change__controls--33bJ5","button":"role-change__button--18yMO"};